import { render, staticRenderFns } from "./PremiacoesSection.vue?vue&type=template&id=aec26c78&scoped=true"
import script from "./PremiacoesSection.vue?vue&type=script&lang=js"
export * from "./PremiacoesSection.vue?vue&type=script&lang=js"
import style0 from "./PremiacoesSection.vue?vue&type=style&index=0&id=aec26c78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec26c78",
  null
  
)

export default component.exports